/**
 * Element Clicked event - tracks when users click on specific elements
 * This event follows the redventures.usertracking.v3.ElementClicked schema
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';

export const ELEMENT_TYPES = {
  MODAL: 'Modal',
  LINK: 'Link',
  BUTTON: 'Button',
  ICON: 'Icon',
  CHECKBOX: 'Checkbox',
  MENU: 'Menu',
  RADIO_BUTTONS: 'Radio Buttons',
};

export default defineEvent({
  eventName: 'redventures.usertracking.v3.ElementClicked',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_1KdMzy1S6c7Aqjibny2JP9HC1Fb
  cohesionSchema: {
    actionOutcome: z.string().optional(), // An action outcome determines the result of a click (e.g. INTERNALLINK, EXTERNALLINK)
    correlationId: z.string().optional(), // correlation id on the click
    outboundUrl: z.string().optional(), // Destination URL resulting from the user's element click
    webElement: z.object({
      // Update as new values identified! Based on known values: https://rvohealth.atlassian.net/wiki/spaces/PA/pages/1789329511/HG+Pro+Portal
      elementType: z.enum(Object.values(ELEMENT_TYPES)).optional(),

      htmlId: z.string().optional(),
      location: z.string().optional(),
      name: z.string().optional(),
      position: z.string().optional(),
      text: z.string().optional(),
    }),
    viewCorrelationId: z.uuid().optional(), // Ties the "element clicked" event back to the "element viewed" event. This will be a 1 to many relationship if there are multiple element clicks to a single element view.
    customDimensions: z
      .array(
        z.object({
          key: z.string(),
          value: z.string(),
        }),
      )
      .optional(), // additional information about the event
    listId: z.string().optional(), // Since Products will be viewed & clicked from a list or product grid, we need a UUID for that product grid instance
  },
});
